module.exports = __webpack_public_path__ + "img/17.df8eafff.webp";